import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CCLContact } from 'src/app/core/interfaces/ccl/ccl-contact';
import { Project } from 'src/app/core/interfaces/production/project';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-ccl-counts-list',
  templateUrl: './ccl-counts-list.component.html',
  styleUrls: ['./ccl-counts-list.component.scss'],
})
export class CclCountsListComponent implements OnInit {
  @Input() status: string;
  statusMessage: string;
  statusNumber: number;

  displayedColumns: string[] = [];

  projectDisplayedColumns: string[] = [
    'customerName',
    'jobaddress',
    'estimatorName',
    'soldByName',
    'contractDate',
    'approvalDate',
    'projectShortName',
  ];
  cclContactDisplayedColumns: string[] = [
    'customerName',
    'contactStageName',
    'jobAddress',
    'estimatorName',
    'soldByName',
    'contractDate',
    'approvalDate',
    'projectShortName',
    'updatedBy',
    'updatedDate',
  ];

  projectDataSource: MatTableDataSource<Project>;
  cclContactDataSource: MatTableDataSource<CCLContact>;
  dataSourceArray: CCLContact[] | Project[] = [];

  // needsFirstContactArray: Project[] = [];
  // inProgressArray: CCLContact[] = [];
  // surveyNeededArray: CCLContact[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.projectDataSource = new MatTableDataSource();
    this.cclContactDataSource = new MatTableDataSource();
    // this.getDataSource(this.status);
    this.route.paramMap.subscribe((params) => {
      this.status = params.get('status') as string;
      this.getDataSource(this.status);
    });
  }

  getDataSource(status: string) {
    this.projectDataSource = new MatTableDataSource();
    this.cclContactDataSource = new MatTableDataSource();
    this.isLoading = true;

    if (status) {
      switch (status) {
        case 'needsFirstContact':
          this.statusNumber = 0;
          this.statusMessage = 'First Contact Needed';
          break;
        case 'inProgress':
          this.statusNumber = 1;
          this.statusMessage = 'In Progress';
          break;
        case 'needsSurvey':
          this.statusNumber = 2;
          this.statusMessage = 'Needs Survey';
          break;
      }
    }

    if (this.statusNumber != undefined) {
      switch (this.statusNumber) {
        case 0:
          this.apiService.getNeedsFirstContact(this.statusNumber).subscribe({
            next: (projectArray) => {
              this.dataSourceArray = projectArray;
              this.projectDataSource = new MatTableDataSource(projectArray);
              this.projectDataSource.paginator = this.paginator;
              this.projectDataSource.sort = this.sort;
              this.isLoading = false;
            },
          });
          break;
        default:
          this.apiService.getCCLContactByStatus(this.statusNumber).subscribe({
            next: (cclContactArray) => {
              this.dataSourceArray = cclContactArray;
              this.cclContactDataSource = new MatTableDataSource(
                cclContactArray
              );
              this.cclContactDataSource.paginator = this.paginator;
              this.cclContactDataSource.sort = this.sort;
              this.isLoading = false;
            },
          });
          break;
      }
    }
  }

  goToCCLContact(row: CCLContact) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        projectId: row.projectId,
        status: row.status,
        cclContact: true,
      },
    });
  }

  filterProjects(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.projectDataSource.filter = filterString.trim().toLowerCase();
  }

  filterCCLContacts(event: Event) {
    const filterString = (event.target as HTMLInputElement).value;
    this.cclContactDataSource.filter = filterString.trim().toLowerCase();
  }
}
